import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionState } from '../../../constants/transaction-state';
import { TransactionGroup } from '../../../models/transaction-group.model';

@Component({
  selector: 'app-order-item-modal',
  templateUrl: './transaction-result-modal.component.html',
  styleUrls: ['./transaction-result-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TransactionResultModalComponent {
  transactionGroup: TransactionGroup;

  constructor(private activeModal: NgbActiveModal) {}

  onStartOver(): void {
    this.close('start_over');
  }

  onClose(): void {
    this.close();
  }

  displayCreditCardLabel(last_four): string {
    return `${last_four}`;
  }

  get isSuccessful(): boolean {
    return this.transactionGroup.totals.state === TransactionState.SUCCESS;
  }

  private close(result = ''): void {
    this.activeModal.close(result);
  }
}
